module.exports = __webpack_public_path__ + "static/img/lanshou.1a7e6bed.png";